/* ============================================================
   VITALIC — GLOBAL INTERACTION LAYER
   Dependency-free. Powers scroll reveals and shared UI hooks.
   Loaded with `defer`. Safe to run on every page.
   ============================================================ */
(function () {
  "use strict";

  var prefersReduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ---- Scroll reveal --------------------------------------- */
  function initReveal() {
    var els = document.querySelectorAll("[data-vita-reveal]");
    if (!els.length) return;

    if (prefersReduced || !("IntersectionObserver" in window)) {
      els.forEach(function (el) { el.classList.add("is-visible"); });
      return;
    }

    var io = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-visible");
          obs.unobserve(entry.target);
        }
      });
    }, { rootMargin: "0px 0px -10% 0px", threshold: 0.12 });

    els.forEach(function (el) { io.observe(el); });
  }

  /* ---- Header shrink on scroll ----------------------------- */
  function initHeaderScroll() {
    var header = document.querySelector("[data-vita-header]");
    if (!header) return;
    var lastY = 0;
    var onScroll = function () {
      var y = window.scrollY || window.pageYOffset;
      header.classList.toggle("is-scrolled", y > 12);
      lastY = y;
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
  }

  /* ---- Generic accordion (data-vita-accordion) ------------- */
  function initAccordions() {
    document.querySelectorAll("[data-vita-accordion] [data-accordion-trigger]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var item = btn.closest("[data-accordion-item]");
        if (!item) return;
        var panel = item.querySelector("[data-accordion-panel]");
        var open = item.classList.toggle("is-open");
        btn.setAttribute("aria-expanded", open ? "true" : "false");
        if (panel) panel.style.maxHeight = open ? panel.scrollHeight + "px" : "0px";
      });
    });
  }

  function ready(fn) {
    if (document.readyState !== "loading") fn();
    else document.addEventListener("DOMContentLoaded", fn);
  }

  ready(function () {
    initReveal();
    initHeaderScroll();
    initAccordions();
  });

  // Re-init reveals when Theme Editor injects/reloads a section
  document.addEventListener("shopify:section:load", function () {
    initReveal();
    initAccordions();
  });
})();
